import type { ComponentProps } from 'react';

type CheckCircleProps = ComponentProps<'svg'> & {
  pathStroke?: string; // Add this line to extend the props
};

const CheckCircle = ({
  fill = '#9FFCE9',
  strokeWidth = '1.52778',
  pathStroke = '#0A7B71',
  ...props
}: CheckCircleProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth={strokeWidth}
      {...props}
    >
      <circle cx="10" cy="10" r="8.75" fill={fill} />
      <path
        d="M7.1875 10.4372L9.4223 12.5L13.1875 7.5"
        stroke={pathStroke}
        stroke-width={strokeWidth}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CheckCircle;
